import React, { use, useEffect } from 'react';
import { Layout, Menu, theme } from 'antd';
import '../../style/component.css'
import SidebarMenu from '../sidebar/SidebarMenu';
import Headers from '../header/Header';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
const { Content, } = Layout;

const MainLayouts = () => {
    const { token, getCurrentUser, user } = useAuth()

    if (!token) {
        return <Navigate replace to="/login" />
    } else {
        return (
            <Layout style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <Headers />
                <Layout style={{ flex: 1, overflow: 'hidden' }}>
                    <SidebarMenu />
                    <Layout className='main'>
                        <Content className='content'>
                            <Outlet />
                        </Content>
                    </Layout>
                </Layout>
            </Layout>
        );
    }

};

export default MainLayouts;
